/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartItem_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItems_user$ref: FragmentReference;
export type CartItems_user = {|
  +$fragmentRefs: CartItem_user$ref,
  +$refType: CartItems_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItems_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartItem_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c80194b6754487e1bdbbc4611d338225';
module.exports = node;
